import { GridApi } from '@ag-grid-community/core'
import {
  convertFilters,
  Filter,
  genericHeliosRequest,
  HeliosServerSideRequest,
} from '@helios/server-side-util'
import {
  Account,
  AccountsRequestContext,
  AdvancedFilterContext,
} from '../models'
import { scopeAccountTypeFilter } from './accountTypeScope'

export const getAccountRowCountRequest = (
  api: GridApi,
  filterContext: AdvancedFilterContext,
): HeliosServerSideRequest<Account, AccountsRequestContext> =>
  getAccountRowCountFromFilter(
    convertFilters(api.getFilterModel() ?? {}),
    filterContext,
  )

export const getAggregateAccountRowCountRequest = (
  api: GridApi,
  filterContext: AdvancedFilterContext,
): HeliosServerSideRequest<Account, AccountsRequestContext> =>
  getScopedAccountRowCountRequest(api, filterContext, ['aggregate'])

export const getSubAccountRowCountRequest = (
  api: GridApi,
  filterContext: AdvancedFilterContext,
): HeliosServerSideRequest<Account, AccountsRequestContext> =>
  getScopedAccountRowCountRequest(api, filterContext, [
    'simple',
    'sleeveAggregate',
    'sleeveSimple',
  ])

/**
 * The count must be built from the same accountType scoping the row fetch uses
 * (see scopeAccountTypeFilter), or the status bar reports a total for account
 * types the grid is not showing.
 */
const getScopedAccountRowCountRequest = (
  api: GridApi,
  filterContext: AdvancedFilterContext,
  allowedValues: Account['accountType'][],
): HeliosServerSideRequest<Account, AccountsRequestContext> => {
  const filter = convertFilters(api.getFilterModel() ?? {})

  return getAccountRowCountFromFilter(
    {
      ...filter,
      accountType: scopeAccountTypeFilter(
        filter.accountType,
        allowedValues,
      ) as Filter,
    },
    filterContext,
  )
}

const getAccountRowCountFromFilter = (
  filter: { [x: string]: Filter },
  filterContext: AdvancedFilterContext,
): HeliosServerSideRequest<Account, AccountsRequestContext> => ({
  ...genericHeliosRequest,
  filter: filter,
  context: {
    filterContext: {
      ...filterContext,
      reconDate: filterContext.reconDate,
    },
  } as AccountsRequestContext,
})
